import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "has-text-centered" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Confirm Sign Up")
], -1)
const _hoisted_4 = { class: "section" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_signUpCustomer = _resolveComponent("v-signUpCustomer")!
  const _component_v_submit = _resolveComponent("v-submit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.modalData.Name=='')
          ? (_openBlock(), _createBlock(_component_v_input, {
              key: 0,
              title: "Full Name",
              type: "string",
              value: _ctx.inputName,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.inputName = $event)),
              error: _ctx.error('inputName')
            }, null, 8, ["value", "error"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" Welcome, " + _toDisplayString(_ctx.modalData.Name) + ", please complete this form.", 1),
              _hoisted_5,
              _hoisted_6
            ], 64)),
        _createVNode(_component_v_input, {
          title: "Verification Code",
          type: "text",
          value: _ctx.verificationCode,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.verificationCode = $event)),
          error: _ctx.error('verificationCode')
        }, null, 8, ["value", "error"]),
        _createVNode(_component_v_signUpCustomer, {
          title: "Customer Survey",
          ref: "customerInfo",
          role: _ctx.role,
          "onUpdate:role": _cache[2] || (_cache[2] = ($event: any) => (_ctx.role = $event)),
          organisation: _ctx.organisation,
          "onUpdate:organisation": _cache[3] || (_cache[3] = ($event: any) => (_ctx.organisation = $event)),
          industry: _ctx.industry,
          "onUpdate:industry": _cache[4] || (_cache[4] = ($event: any) => (_ctx.industry = $event)),
          sector: _ctx.sector,
          "onUpdate:sector": _cache[5] || (_cache[5] = ($event: any) => (_ctx.sector = $event)),
          introduction: _ctx.introduction,
          "onUpdate:introduction": _cache[6] || (_cache[6] = ($event: any) => (_ctx.introduction = $event))
        }, null, 8, ["role", "organisation", "industry", "sector", "introduction"]),
        _createVNode(_component_v_submit, {
          loading: _ctx.loading('signUpConfirm'),
          submitTitle: "Confirm",
          cancelTitle: "Cancel",
          onSubmit: _ctx.signUpConfirm,
          onCancel: _ctx.cancel
        }, null, 8, ["loading", "onSubmit", "onCancel"])
      ])
    ])
  ]))
}